var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, useTheme } from '@mui/material';
import { FlexCol, FlexGrowCol, FlexGrowRow, FlexRow } from '@xyo-network/sdk-xyo-react-js';
import { DateTime } from 'luxon';
import numeral from 'numeral';
import { useContext, useEffect, useState } from 'react';
import { UserStatsContext } from '../contexts';
import StatCardHeader from './StatCardHeader';
const dateFormat = 'yyyyMMdd';
const getDataPoints = (start, end) => {
    const dataPoints = [];
    for (let i = start; i <= end; i = i.plus({ days: 1 })) {
        dataPoints.push({ key: i.toISO(), label: i.toFormat('MMM d'), value: 0 });
    }
    return dataPoints;
};
const Earnings = (_a) => {
    var { dynamicMin, onRefreshClick, yaxis } = _a, props = __rest(_a, ["dynamicMin", "onRefreshClick", "yaxis"]);
    const [end] = useState(DateTime.fromFormat(DateTime.now().toFormat(dateFormat), dateFormat));
    const [start] = useState(end.minus({ days: 6 }));
    const { stats } = useContext(UserStatsContext);
    const [dataPoints, setDataPoints] = useState();
    const [max, setMax] = useState();
    const [min, setMin] = useState();
    const [total, setTotal] = useState();
    const theme = useTheme();
    const onRefreshClickLocal = () => {
        onRefreshClick === null || onRefreshClick === void 0 ? void 0 : onRefreshClick();
    };
    useEffect(() => {
        var _a;
        const dataPoints = getDataPoints(start, end);
        let max = undefined;
        let min = 0;
        let total = 0;
        (_a = stats === null || stats === void 0 ? void 0 : stats.forEach) === null || _a === void 0 ? void 0 : _a.call(stats, (item) => {
            var _a;
            const itemDate = DateTime.fromFormat(`${item.yyyymmdd}`, dateFormat);
            const delta = itemDate.diff(start, 'days');
            const index = Math.floor(delta.days);
            //protect against incoming data
            if (index >= 0 && index < dataPoints.length) {
                const plotNumber = (_a = item.collected) !== null && _a !== void 0 ? _a : 0;
                max = max !== undefined ? (plotNumber > max ? plotNumber : max) : plotNumber;
                min = plotNumber < min ? plotNumber : min;
                total += plotNumber;
                dataPoints[index].value = plotNumber;
            }
        });
        setDataPoints(dataPoints);
        setMax(max);
        setMin(min);
        setTotal(total);
    }, [stats, start, end]);
    const minToUse = dynamicMin ? min : 0;
    const range = (max !== null && max !== void 0 ? max : 0) - (minToUse !== null && minToUse !== void 0 ? minToUse : 0);
    const barHeightPerPercent = 100 / range;
    return (_jsxs(FlexCol, Object.assign({ paper: true, busy: stats === undefined, alignItems: "stretch", flexGrow: 1 }, props, { children: [_jsx(StatCardHeader, { title: total === undefined ? '- -' : `${numeral(total).format('0,0.00')}`, subtitle: "COIN earned this week", onRefreshClick: onRefreshClickLocal }, void 0), _jsxs(FlexGrowRow, Object.assign({ alignItems: "stretch", justifyContent: "stretch", padding: 2 }, { children: [yaxis ? (_jsxs(FlexCol, Object.assign({ justifyContent: "space-between" }, { children: [_jsx(Typography, { children: max }, void 0), _jsx(FlexCol, Object.assign({ marginBottom: 2 }, { children: _jsx(Typography, { children: min }, void 0) }), void 0)] }), void 0)) : null, dataPoints
                        ? dataPoints.map((dataPoint) => {
                            return (_jsxs(FlexGrowCol, Object.assign({ justifyContent: "flex-end", alignItems: "stretch" }, { children: [_jsxs(FlexRow, Object.assign({ height: `${dataPoint.value * barHeightPerPercent}%`, borderBottom: "1px solid", borderColor: theme.palette.text.primary, marginBottom: 1, alignItems: "stretch" }, { children: [_jsx(FlexCol, { flexGrow: 1 }, void 0), _jsx(FlexCol, Object.assign({ flexGrow: 8, alignItems: "center", bgcolor: theme.palette.secondary.light, color: theme.palette.getContrastText(theme.palette.secondary.light) }, { children: _jsx(FlexRow, Object.assign({ position: "absolute", top: 0 }, { children: _jsx(Typography, Object.assign({ variant: "button" }, { children: numeral(dataPoint.value).format('0,0.00a') }), void 0) }), void 0) }), void 0), _jsx(FlexCol, { flexGrow: 1 }, void 0)] }), void 0), _jsx(FlexRow, Object.assign({ marginTop: 2 }, { children: _jsx(Typography, Object.assign({ variant: "subtitle2" }, { children: dataPoint.label }), void 0) }), void 0)] }), dataPoint.key));
                        })
                        : null] }), void 0)] }), void 0));
};
export default Earnings;
//# sourceMappingURL=Earnings.js.map